import type { SxProps, Theme } from '@mui/material';

/**
 * Dark gradient background used across multiple layouts
 */
export const DARK_GRADIENT_BACKGROUND =
  'linear-gradient(244deg, #121836 0%, #070818 99.27%) !important';

/**
 * Base container styles for layouts with dark gradient background
 */
export const darkGradientContainerSx: SxProps<Theme> = {
  backgroundImage: DARK_GRADIENT_BACKGROUND,
  width: 'fit-content',
  minWidth: '100%'
};

/**
 * Common content wrapper styles for centered layouts
 */
export const centeredContentWrapperSx: SxProps<Theme> = {
  minHeight: '100vh',
  height: '100%',
  minWidth: '300px',
  display: 'flex',
  justifyContent: 'center'
};
